import { emptyPaginated } from '@sketch/modules-common'
import { ApolloClient } from '@apollo/client'

export interface HandleEmptiedWorkspaceTrashProps {
  client: ApolloClient<unknown>
  identifier: string
}

export const handleEmptiedWorkspaceTrash = (
  props: HandleEmptiedWorkspaceTrashProps
) => {
  const { client, identifier } = props

  emptyPaginated(
    client,
    key =>
      (key.startsWith('Workspace:') &&
        key.includes(identifier) &&
        key.includes('.storageItems(') &&
        key.includes('TRASH')) ||
      // TODO: remove this clause once nested-projects FF will be turned on to 100%
      (key.includes('ROOT_QUERY.workspaceTrash') && key.includes(identifier)),
    (entry: any) => {
      if ('sharesCount' in entry) {
        entry.sharesCount = 0
      }
      if ('nestedProjectsCount' in entry) {
        entry.nestedProjectsCount = 0
      }
    }
  )
}
